import {
  Nav,
  NavDropdown,
  Carousel,
  Container,
  Form,
  Button,
  Modal,
  Col,
  Row,
  ListGroup,
  Image,
  NavItem,
  NavLink,
} from "react-bootstrap";
import React, { Link, useParams, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import useLocationUser from "../../contexts/location";
import {
  getHighlightedProducts,
  searchProductInCityCategory,
} from "../../services/api";
import "./styles.scss";
import ProductCard from "../../components/ProductCard";
import Loader from "../../components/Loader/Loader";
import { GoChevronDown } from "react-icons/go";
import { BiSortDown, BiSortUp } from "react-icons/bi";
import LoadingIndicator from "../../components/LoadingIndicator";
import Footer from "../../components/Footer";
import debounce from "lodash.debounce";

import PaginationComponent from "../../components/Pagination";
import { Helmet } from "react-helmet";
import { textEllipsis } from "../../utils/mappers";
import qs from "qs";
import qr from "../../assets/img/QR Code - Grupos de Ofertas.png"
import useCategories from "../../hooks/useCategories";
export default function Marketplace({ match, location }) {
  const [categorySelected, setCategorySelected] = useState("Todas as categorias");
  const [query, setQuery] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [page, setPage] = useState();
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [status, setStatus] = useState("loading");
 const history = useHistory();
  const { idCategory } = useParams();
  const { subCat } = useParams();
  const [lastCategory, setLastCategory] = useState(idCategory);
  const [selectedSubCategory, setSelectedSubCategory] = useState(subCat);
  
  const [ascOrDesc, setAscOrDesc] = useState("DESC");
  const [highlights, setHighlights] = useState(null);
  const [loadingHighlights, setLoadingHighlights] = useState(true);
  const q = qs.parse(location.search, { ignoreQueryPrefix: true }).q;

  // ---- Categorias estilo Indica (pills horizontais) ----
  const categories = useCategories();
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const normalizeCategoryName = (value = "") =>
    value
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .trim();
  const tvExcludedPattern = /audio\s*e\s*video/;
  const tvStrongPattern = /\bsmart\s*tv\b|\bsmart\s*tvs\b|\btelevisor\b|\btelevisores\b|\btelevis/;
  const tvLoosePattern = /\btv\b|\btvs\b/;
  const isTvCategory = (category) => {
    const normalized = normalizeCategoryName(category?.name);
    if (!normalized || tvExcludedPattern.test(normalized)) return false;
    return tvStrongPattern.test(normalized) || tvLoosePattern.test(normalized);
  };
  const getMainCategoryLabel = (category) => (isTvCategory(category) ? "TVS" : category.name);
  const findBestTvCategory = (items) => {
    const scored = items
      .map((item) => {
        const normalized = normalizeCategoryName(item?.name);
        if (!normalized || tvExcludedPattern.test(normalized)) return null;
        if (/^tvs?$/.test(normalized)) return { item, score: 100 };
        if (/^smart\s*tvs?$/.test(normalized)) return { item, score: 95 };
        if (tvStrongPattern.test(normalized)) return { item, score: 90 };
        if (tvLoosePattern.test(normalized)) return { item, score: 80 };
        return null;
      })
      .filter(Boolean)
      .sort((a, b) => b.score - a.score);
    return scored[0]?.item;
  };
  const resolveFeaturedCategories = (items) => {
    const blockedMainPattern = /acessor|veicul|auto\s*peca/;
    const preferredResolvers = [
      () => items.find((item) => /celular|smartphone|iphone|android/.test(normalizeCategoryName(item?.name))),
      () => findBestTvCategory(items),
      () => items.find((item) => /informatica|notebook|computador|tablet/.test(normalizeCategoryName(item?.name))),
      () => items.find((item) => /movel|moveis|casa/.test(normalizeCategoryName(item?.name))),
      () => items.find((item) => /eletrodomestico|eletro|cozinha|geladeira|ar-condicionado/.test(normalizeCategoryName(item?.name))),
    ];
    const selected = [];
    const selectedIds = new Set();
    preferredResolvers.forEach((resolver) => {
      const found = resolver();
      if (found && !selectedIds.has(found.id)) {
        selected.push(found);
        selectedIds.add(found.id);
      }
    });
    items.forEach((item) => {
      if (selected.length >= 5) return;
      const normalized = normalizeCategoryName(item?.name);
      const isBlockedMain = normalized && blockedMainPattern.test(normalized);
      if (!selectedIds.has(item.id) && !isBlockedMain) {
        selected.push(item);
        selectedIds.add(item.id);
      }
    });
    return selected.slice(0, 5);
  };
  const featuredCategories = resolveFeaturedCategories(categories || []);
  const activeCategoryId = idCategory || null;

  const preserveSearchSuffix = q ? `?q=${encodeURIComponent(q)}` : "";

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setShowCategoryModal(true);
  };
  const handleOpenAllDepartments = () => {
    setSelectedCategory(null);
    setShowCategoryModal(true);
  };
  const handleOpenCategoryResults = (categoryId) => {
    setShowCategoryModal(false);
    history.push(`/categoria/${categoryId}${preserveSearchSuffix}`);
  };
  const handleSubCategoryClick = (subCategoryId) => {
    setShowCategoryModal(false);
    history.push(`/subCategory/${subCategoryId}${preserveSearchSuffix}`);
  };

  
  useEffect(() => {
    const p = sessionStorage.getItem("@app_mercadim:p");
    if (p) {
      setPage(Number(p));
    }
  }, []);
  useEffect(() => {
    if (selectedSubCategory !== subCat) {
      setSelectedSubCategory(subCat);
    setPage(0); // Reinicia a paginação
    setResults([]); // Limpa os resultados existentes
    setStatus("loading");
    }
  }, [selectedSubCategory, subCat]);
  useEffect(() => {
    if (lastCategory !== idCategory) {
      setLastCategory(idCategory);
    setPage(0); // Reinicia a paginação
    setResults([]); // Limpa os resultados existentes
    setStatus("loading");
    }
  }, [lastCategory, idCategory]);
  useEffect(() => {
    sessionStorage.setItem("@app_mercadim:q", query);
    setPage(1); // Reinicia a paginação
    setResults([]); // Limpa os resultados existentes
    setStatus("loading");
  }, [query]);
  useEffect(() => {
    // Sincroniza o termo de busca com a query da URL (?q=...) vinda do header
    // e reinicia paginação/resultados pra refletir a nova busca
    setQuery(q || "");
    setPage(1);
    setResults([]);
    setStatus("loading");
  }, [q]);
  useEffect(() => {
    if (!q) {
      sessionStorage.setItem("@app_mercadim:p", page);

    }
  }, [page, q]);
  useEffect(() => {
    getHighlightedProducts().then((data) => {
      setHighlights(data);
      setLoadingHighlights(false);
    });
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    
    /*setTimeout(async () => {*/
    // Usa o termo de busca da URL (?q=) com prioridade — sempre reflete a busca do header
    const term = ((q || query) || "").trim();
    if (lastCategory) {

      const payload = {
        nameProduto: term,
        category_id: lastCategory,
        ...(!showAll),
      };

      searchProductInCityCategory(payload, page, ascOrDesc).then((data) => {
        setResults((prev) => {
          const updatedData = data.data.filter(newItem => !prev.some(item => item.id === newItem.id));
          return [...prev, ...updatedData];
        });

        setStatus("result");
      });
    } else if (selectedSubCategory != null) {
      const payload = {
        category_type_id: selectedSubCategory,
        nameProduto: term,
        ...(!showAll),
      };

      searchProductInCityCategory(payload, page, ascOrDesc).then((data) => {
        setResults((prev) => {
          const updatedData = data.data.filter(newItem => !prev.some(item => item.id === newItem.id));
          return [...prev, ...updatedData];
        });
        setStatus("result");
      });
    } else {
      setCategorySelected("Categorias");

      const dados = {
        nameProduto: term,
        category_id: lastCategory,
        ...(!showAll),
      };
      searchProductInCityCategory(dados, page, ascOrDesc).then((data) => {
        setResults((prev) => {
          const updatedData = data.data.filter(newItem => !prev.some(item => item.id === newItem.id));
          return [...prev, ...updatedData];
        });
        setStatus("result");
      });
    }
   /*  }, 1500);*/
  }, [lastCategory, selectedSubCategory, page, query, ascOrDesc, showAll, q]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScroll = async () => {
    const nearBottom = window.innerHeight + document.documentElement.scrollTop + 1 >= document.documentElement.scrollHeight;
    if (nearBottom && status === "loading") {
      setStatus("result");  // Atualiza o estado para 'loading' antes de carregar mais dados
      setPage((prev) => prev + 1);
    }
  };
  function renderResults() {

    if (status !== "result") {
      return null;
    }

    if (results.length === 0) {
      return (
        <>
          <Container>
            <Row>
              <Col className="my-5">
                <h5 className="text-muted text-center my-5">Sem resultados</h5>
              </Col>
            </Row>
          </Container>
        </>
      );
    }

    return (
      <>
        <Container>
          <Row className="">
            {results.map((product, index) => (
             <Col key={index} xs={12} sm={6} lg={4} xl={3} style={{marginBlockEnd:'25px'}}>
                <ProductCard product={product} />
              </Col>
              
            ))}
           
          </Row>
          <div style={{ margin: "80px" }}></div>
        </Container>
      </>
    );
    
  }
  return (
    <>
      <Helmet title="Caçadores de Ofertas: Marketplace" />
      <div className="marketplace-main-wrapper">
        <br></br>
        {!loadingHighlights && highlights && highlights.length > 0 && (
          <Container fluid>
          <div className="row">
            <Carousel className="center background carousel" controls={true} indicators={true}>
              {highlights.map((h) => (
                <Carousel.Item key={h.id}>
                  <div className="d-flex justify-content-center align-items-center" style={{ height: "450px", margin: "20px 0" }}>
                    <a href={h.link} target="_blank" rel="noopener noreferrer">
                      <Image
                        src={h.image_url}
                        width='100%' // Tornar responsivo
                        style={{ objectFit: 'contain' }} // Evitar distorção da imagem
                        className="d-block center"
                      />
                    </a>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </Container>
        
        )}

        <div className="carousel-categories-wrapper">
          <Container fluid>
            <div className="carousel-categories-shell magalu-categories-shell">
              <h6 className="carousel-categories-title">Categorias</h6>
              <div className="magalu-categories-row" role="navigation" aria-label="Categorias em destaque">
                <button
                  type="button"
                  className="magalu-departments-button"
                  onClick={handleOpenAllDepartments}
                >
                  Todos os departamentos
                </button>
                {featuredCategories.map((category) => (
                  <button
                    key={category.id}
                    type="button"
                    className={`magalu-main-category ${String(activeCategoryId) === String(category.id) ? "active" : ""}`}
                    onClick={() => handleOpenCategoryResults(category.id)}
                  >
                    {getMainCategoryLabel(category)}
                  </button>
                ))}
              </div>
            </div>
          </Container>
        </div>

        <Modal
          show={showCategoryModal}
          onHide={() => setShowCategoryModal(false)}
          centered
          className="marketplace-category-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{selectedCategory ? selectedCategory.name : "Todos os departamentos"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!selectedCategory ? (
              <div className="marketplace-subcategory-list">
                {(categories || []).map((category) => (
                  <button
                    key={category.id}
                    type="button"
                    className="carousel-subcategory-item"
                    onClick={() => handleCategoryClick(category)}
                  >
                    {category.name}
                  </button>
                ))}
              </div>
            ) : selectedCategory.category_types && selectedCategory.category_types.length > 0 ? (
              <div className="marketplace-subcategory-list">
                {selectedCategory.category_types.map((subCategory) => (
                  <button
                    key={subCategory.id}
                    type="button"
                    className="carousel-subcategory-item"
                    onClick={() => handleSubCategoryClick(subCategory.id)}
                  >
                    {subCategory.name}
                  </button>
                ))}
              </div>
            ) : (
              <p className="text-muted text-center my-3">Nenhuma subcategoria.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            {selectedCategory && (
              <Button variant="primary" onClick={() => handleOpenCategoryResults(selectedCategory.id)}>
                Ver todas as ofertas de {selectedCategory.name}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Container fluid>
          <div style={{ margin: "20px" }}></div>
          {renderResults()}
          {status === "loading" && <Loader />}
        </Container>
      </div>
      <Footer />
    </>
  );
}





